<div class="meeting-form">
  <ng-container *ngIf="user$ | async; else loading">
    <div class="login-form" *ngIf="!user?.ID; else loggedIn">
      <ng-container>
        <div class="logged-out">
          <h2 class="mb-3">Review meeting AI summary with LF Account</h2>
          <div class="flex justify-center items-center gap-2">
            <button (click)="onLogin()" [disabled]="skipAuth0()">Sign In</button>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="create-account" *ngIf="!user?.ID">
      <h2>Your LF Account allows you to:</h2>

      <div class="benefits-list">
        <div class="benefit">
          <i class="fa-light fa-chart-column"></i>
          <span>Browse your contributions and community activities</span>
        </div>
        <div class="benefit">
          <i class="fa-light fa-video"></i>
          <span>Access to all meeting recordings and transcripts</span>
        </div>
        <div class="benefit">
          <i class="fa-light fa-envelope"></i>
          <span>Easily manage your communication preferences</span>
        </div>
      </div>
      <h2><strong>Don't have an account?</strong> Creating an LF account only takes a moment, and you get the following benefits...</h2>

      <button *ngIf="(!user || !user?.ID) && !skipAuth0()" (click)="onLogin(true)">Create LF Account</button>
    </div>
  </ng-container>
</div>
<ng-template #loggedIn>
  <div class="meeting-summary-form" *ngIf="(permissions$ | async) && (registrant$ | async); else loading" [formGroup]="form">
    <div class="flex flex-col w-full gap-4">
      <div class="flex flex-row">
        <span class="text-sm font-bold"
          >Please review and edit the meeting summary generated by Zoom and click save to publish the summary to participants via their Individual Dashboard and
          Public Calendar.</span
        >
      </div>
      <div class="flex flex-col w-full gap-6">
        <div class="flex flex-col w-full gap-4">
          <span class="text-sm font-bold">Quick Recap</span>
          <p *ngIf="!editMode" [innerHTML]="form.value.recap || 'No recap available'"></p>
          <p-editor *ngIf="editMode" class="min-h-150 h-auto" formControlName="recap" placeholder="Enter Recap">
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
              </span>
            </ng-template>
          </p-editor>
        </div>
        <div class="flex flex-col w-full gap-4">
          <span class="text-sm font-bold">Next Steps</span>
          <div *ngIf="!editMode" [innerHTML]="form.value.nextSteps || 'No next steps available'"></div>
          <p-editor *ngIf="editMode" class="min-h-150 h-auto" formControlName="nextSteps" placeholder="Enter Next Steps">
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-list" aria-label="List" value="ordered"></button>
                <button type="button" class="ql-list" aria-label="Bullet" value="bullet"></button>
              </span>
            </ng-template>
          </p-editor>
        </div>
        <div class="flex flex-col w-full gap-4">
          <span class="text-sm font-bold">Summary</span>
          <p *ngIf="!editMode" [innerHTML]="form.value.summary || 'No summary available'"></p>
          <p-editor *ngIf="editMode" class="min-h-150 h-auto" formControlName="summary" placeholder="Enter Summary">
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
              </span>
            </ng-template>
          </p-editor>
        </div>
      </div>
      <div *ngIf="editMode" class="flex justify-end items-center gap-6">
        <a *ngIf="!formLoading" class="text-black text-13 cursor-pointer" (click)="switchEditMode()">Cancel</a>
        <button pButton type="button" class="p-button-primary" [disabled]="formLoading" (click)="onSave(false)">
          Save draft <i *ngIf="formLoading" class="fa-light fa-circle-notch fa-spin ml-1"></i>
        </button>
      </div>
      <div *ngIf="!editMode && canManage" class="flex justify-end items-center gap-6">
        <button *ngIf="showApproveCTA" pButton type="button" class="p-button-primary" [disabled]="formLoading" (click)="onSave(true)">
          Publish <i *ngIf="formLoading" class="fa-light fa-circle-notch fa-spin ml-1"></i>
        </button>
        <button pButton type="button" class="p-button-primary" [disabled]="formLoading" (click)="switchEditMode()">Edit</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="flex justify-center items-center h-full">
    <p-skeleton height="100%" width="100%"></p-skeleton>
  </div>
</ng-template>
